import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { BroadcastService } from './broadcast.service';
import { EventType } from '../models/broadcast-auth-event.interface';
import { IAuthorizationResponseContract } from '../models/authorization';

@Injectable()
export class AuthStateService {
  constructor(
    private broadcastService: BroadcastService,
    private authService: AuthenticationService,
  ) {
    this.bindLoginFailureEvents();
    this.bindLoginSuccessEvent();
    this.bindLogoutEvent();
  }
  /**
   * Subscription to login failures, used to handle redirects if the session expires or does not exist.
   */
  private subscriptions: Subscription[] = [];

  public ngOnDestroy() {
    this.subscriptions.forEach((item) => {
      item.unsubscribe();
    });
  }

  private bindLoginFailureEvents() {
    const loginFailure = () => {
      this.authService.loginRedirect();
    };

    this.subscriptions.push(
      this.broadcastService.broadcast$
        .pipe(
          filter(
            (evt) =>
              typeof evt === 'object' && evt.type === EventType.LOGIN_FAILURE,
          ),
        )
        .subscribe(loginFailure),
    );
    this.subscriptions.push(
      this.broadcastService.broadcast$
        .pipe(
          filter(
            (evt) =>
              typeof evt === 'object' &&
              evt.type === EventType.ACQUIRE_TOKEN_FAILURE,
          ),
        )
        .subscribe(loginFailure),
    );
  }

  private bindLogoutEvent() {
    this.subscriptions.push(
      this.broadcastService.broadcast$
        .pipe(
          filter(
            (evt) =>
              typeof evt === 'object' && evt.type === EventType.USER_LOGOUT,
          ),
        )
        .subscribe(() => {
          this.authService.logout();
        }),
    );
  }

  private bindLoginSuccessEvent() {
    this.subscriptions.push(
      this.broadcastService.broadcast$
        .pipe(
          filter((evt) => {
            return (
              typeof evt === 'object' && evt.type === EventType.LOGIN_SUCCESS
            );
          }),
        )
        .subscribe(({ payload }) => {
          this.authService.loginSuccess(
            payload as IAuthorizationResponseContract,
          );
        }),
    );
  }
}
